module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allowedGroups":"Allowed groups","close":"Close","dashboard":"Dashboard","discussion":"Discussion","returnToList":"Return to list","sites":"Sites","useOf":"Use of"},"fr":{"allowedGroups":"Groupes autorisés","close":"Fermer","dashboard":"Tableau de bord","discussion":"Discussion","returnToList":"Retour à la liste","sites":"Sites","useOf":"Utilisation de"}}')
  delete Component.options._Ctor
}
